import { Component, Injectable, ViewChild, OnInit} from '@angular/core';
import { RequestsService } from '../../services/requests.service';
import { ToastService } from '../../services/toast.service';
import { CustomvalidationService } from '../../services/customvalidation.service';
import { ModalComponent, ModalConfig } from '../../_helpers/modal/modal.component'
import { ModalperguntaComponent } from '../../_helpers/modalpergunta/modalpergunta.component'
import { Dataset } from '../../models/dataset.model';
import { Projeto } from '../../models/projeto.model';
import { Tenant } from '../../models/tenant.model';
import { MonacoEditorComponent } from '@materia-ui/ngx-monaco-editor';
import { FormControl, FormGroup, Validators, FormBuilder } from '@angular/forms';
import { ModaltooltipComponent } from '../../_helpers/modaltooltip/modaltooltip.component';
import { FocusMonitor, FocusOrigin } from '@angular/cdk/a11y';

@Component({
  selector: 'add-dataset',
  styleUrls: ['./add-dataset.component.scss'],
  templateUrl: "./add-dataset.component.html"
})

export class AddDatasetComponent implements ModalConfig {
  datasetForm: FormGroup;
  submitted = false;
  disableSubmit = false;
  public data: string;
  public modalTitle = "Cadastro/Edição de Dataset";
  public closeButtonLabel = "Fechar";
  public modalperguntaTitle = "Tem certeza que gostaria de excluir o Dataset?";
  public idProjeto;
  public projetos: Projeto[];
  public tenants: Tenant[];
  public modaltooltipTitle = "Script C#";
  public modaltooltipDescricao = "Essa ferramenta possibilita que a construção da consulta seja feita através de um código C#. Assim, se faz necessária a declaração de uma varíavel cujo retorno é realizado posteriomente.";

  editorOptions = {theme: 'vs-dark', language: 'json'};
  @ViewChild('editor', { static: true }) private editor: MonacoEditorComponent
  @ViewChild('modal', { static: true }) private modalComponent: ModalComponent
  @ViewChild('modalpergunta', { static: true }) private modalperguntaComponent: ModalperguntaComponent
  @ViewChild('modaltooltip', { static: true }) private modaltooltip: ModaltooltipComponent

  dataset: Dataset = new Dataset();

  constructor (private formBuilder: FormBuilder,
     private requestService: RequestsService,
     private customValidation: CustomvalidationService,
     private toastService: ToastService,
     private focusMonitor: FocusMonitor ) { }

  ngOnInit() {
    this.datasetForm = this.formBuilder.group({
      nome: ['', Validators.required],
      projeto: [''],
      tenant: ['', Validators.required],
      comando: [''],
      resultadoComplexo: [''],
      scriptCsharp: [''],
      editor: [''],
      dadosdaUrl: [''],
      url: [''],
      token: [''],
      idAutorizacao: [''],
      idRequisicao: ['']
    }, {
      validators: [this.customValidation.checkboxConditionalRequired('resultadoComplexo', 'comando', false),
        this.customValidation.checkboxConditionalRequired('dadosdaUrl', 'url', true),
        this.customValidation.checkboxConditionalRequired('dadosdaUrl', 'token', true),
        this.customValidation.checkboxConditionalRequired('dadosdaUrl', 'idAutorizacao', true),
        this.customValidation.checkboxConditionalRequired('dadosdaUrl', 'idRequisicao', true),
        this.customValidation.checkboxConditionalRequired('dadosdaUrl', 'editor', false)]
    })
  }

  //ngAfterViewInit() {
  //  this.focusMonitor.stopMonitoring(this.CSharptooltipbtn);
  //}

  get f() { return this.datasetForm.controls; }

  public hideDismissButton() {
    return true;
  }
  
  async abrir(registro, idProjeto) {
    this.disableSubmit = false;
    this.submitted = false;
    this.datasetForm.markAsUntouched();

    if (registro)
      this.dataset = registro;
    else
      this.dataset = new Dataset();

    this.idProjeto = idProjeto;
    this.iniciar();
    return await this.modalComponent.open();
  }

  async fechar() {
    await this.modalComponent.close();
  }


  jsonObject(str) {
    if (!str)
      return "";

    return JSON.parse(str.replace(/(['"])?([a-z0-9A-Z_]+)(['"])?:/g, '"$2": '));
  }

  validateJson(str) {

    try {
      this.jsonObject(str);
      return true;
    }
    catch (e) {
      return false;
    }
  }

  salvar() {
    this.submitted = true;

    this.limparCampos();

    if (this.datasetForm.invalid) {
      return;
    }

    if (!this.dataset.dadosdaUrl) {
      if (this.editor.validate()) {
        alert("Json em formato incorreto!");
      }
    }

    this.disableSubmit = true;
    this.dataset.idProjeto = this.idProjeto;
    var request = this.dataset.idDataset > 0 ? this.requestService.updateDataset(this.dataset) : this.requestService.insertDataset(this.dataset);
    request.subscribe(rsp => {
      this.fechar();
      this.toastService.showSuccess("Dataset salvo com sucesso.")
    }, err => {
      this.disableSubmit = false;
    });
  }

  async delete(id) {
    await this.modalperguntaComponent.open();
    return await this.modalperguntaComponent.continue(this.modalperguntaComponent.isConfirmed);
  }

  iniciar() {
    this.requestService.getProjeto(this.idProjeto).subscribe(x => {
      this.projetos = [x];
    });

    this.requestService.listTenantsByProjeto(this.idProjeto).subscribe(x => {
      this.tenants = x;
    });
  }

  limparCampos() {
    if (this.dataset.dadosdaUrl) {
      this.dataset.dataFieldsJson = "{}";
      this.dataset.comando = "";
      this.dataset.resultadoComplexo = false;
      this.dataset.scriptCsharp  = false;
      this.datasetForm.controls['comando'].setErrors(null);
    }
    else {
      this.dataset.url = "";
      this.dataset.token = "";
    }
  }

  abrirTooltipCsharpScript() {
    this.modaltooltip.open()
  }
}
